const ARROW_ICON_SIZE = 32;
const MAX_BUTTON_MARGIN = 10;
const TEXT_BUTTON_SIZE = 23;

export const ARROW_BUTTON_HEIGHT = ARROW_ICON_SIZE + MAX_BUTTON_MARGIN;
export const TEXT_BUTTON_HEIGHT = TEXT_BUTTON_SIZE + 2 * MAX_BUTTON_MARGIN;
